<template>
  <div>
    <common-table :table-columns="tableColumns"
                  :url="url" :operate="operate"
                  :form-fields="formFields"
                  :permission="permission"
                  :buttons="buttons"
                  :searchs="searchs"
                  ref="table"></common-table>

    <!--修改金额弹出框-->
    <div class="dialog">
      <el-dialog title="修改积分" :visible.sync="moneyVisible" custom-class="common-dialog" :close-on-click-modal="false" width="30%">
        <div class="dialog_body">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="积分余额" name="balance">

              <el-form label-position="right" status-icon label-width=""
                       :model="moneyForm" ref="moneyForm">

<!--                <el-form-item label="" prop="balance" :rules="[]">
                  <div>
                    <el-select v-model="moneyForm.balanceType" placeholder="请选择钱包类型" @change="balanceTypeChange" clearable>
                      <el-option :key="1" label="智能账户" :value="1"/>
                      <el-option :key="2" label="促销账户" :value="2"/>
                      <el-option :key="3" label="活期账户" :value="3"/>
                    </el-select>
                  </div>
                </el-form-item>-->

                <el-form-item label="" prop="balance" :rules="[]">
                  <div>
                    <el-input placeholder="当前余额" v-model="moneyForm.balance">
                      <template slot="prepend">当前余额(USDT)</template>
                    </el-input>
                  </div>
                </el-form-item>

                <el-form-item label="" prop="money" :rules="[]">
                  <div style="margin-top: 15px;">
                    <el-input placeholder="请输入积分" v-model="moneyForm.money" class="input-with-select">
                      <el-select style="width: 120px" v-model="moneyForm.type" slot="prepend" placeholder="请选择">
                        <el-option label="加积分" value="1"></el-option>
                        <el-option label="减积分" value="0"></el-option>
                      </el-select>
                    </el-input>
                  </div>
                </el-form-item>

                <el-form-item label="">
                  <el-radio-group v-model="moneyForm.fixedMoney" size="small">
                    <el-radio-button border label="1000">1000</el-radio-button>
                    <el-radio-button border label="2000">2000</el-radio-button>
                    <el-radio-button border label="3000">3000</el-radio-button>
                    <el-radio-button border label="5000">5000</el-radio-button>
                    <el-radio-button border label="10000">10000</el-radio-button>
                    <el-radio-button border label="20000">20000</el-radio-button>
                    <el-radio-button border label="30000">30000</el-radio-button>
                  </el-radio-group>
                </el-form-item>

<!--                <el-form-item label="" prop="verCode" :rules="[]">
                  <div>
                    <el-input placeholder="谷歌验证码" v-model="moneyForm.verCode">
                      <template slot="prepend">谷歌验证码</template>
                    </el-input>
                  </div>
                </el-form-item>-->

<!--                <el-form-item label="Tg验证码:" prop="tgCode" :rules="[{ required: true, message: '纸飞机验证码不能为空', trigger: 'blur'}]">
                  &lt;!&ndash;<el-input v-model="resetForm.tgCode" placeholder="请输入Tg验证码"></el-input>&ndash;&gt;
                  <template>
                    <el-col :span="10" style="margin-right: 10px">
                      <el-input v-model="moneyForm.tgCode" placeholder="请输入纸飞机验证码"></el-input>
                    </el-col>
                    <el-col :span="10">
                      <el-button type="primary" @click="getCode('/system/getTgCode/updateMoney',60,'updateMoney')" :disabled="codeDisabled.updateMoney">{{codeName.updateMoney}}</el-button>
                    </el-col>
                  </template>
                </el-form-item>-->

              </el-form>
            </el-tab-pane>
            <!--<el-tab-pane label="促销金额" name="promotion">

            </el-tab-pane>-->
          </el-tabs>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="moneyVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitMoneyForm">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--修改额度弹出框-->
    <div class="dialog">
      <el-dialog title="修改额度" :visible.sync="depositVisible" custom-class="common-dialog" :close-on-click-modal="false" width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width=""
                   :model="moneyForm" ref="moneyForm">
            <el-form-item label="" prop="balance" :rules="[]">
              <div>
                <el-select v-model="moneyForm.balanceType" placeholder="请选择存款额度类型" @change="depositTypeChange" clearable>
                  <el-option :key="1" label="基础存款额度" :value="1"/>
                  <el-option :key="2" label="促销存款额度" :value="2"/>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item label="" prop="balance" :rules="[]">
              <div>
                <el-input placeholder="当前额度" v-model="moneyForm.balance">
                  <template slot="prepend">当前额度(USDT)</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="" prop="money" :rules="[]">
              <div style="margin-top: 15px;">
                <el-input placeholder="请输入金额(USDT)" v-model="moneyForm.money" class="input-with-select">
                  <el-select style="width: 120px" v-model="moneyForm.type" slot="prepend" placeholder="请选择">
                    <el-option label="加款" value="1"></el-option>
                    <el-option label="减款" value="0"></el-option>
                  </el-select>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="">
              <el-radio-group v-model="moneyForm.fixedMoney" size="small">
                <el-radio-button border label="1000">1000USDT</el-radio-button>
                <el-radio-button border label="2000">2000USDT</el-radio-button>
                <el-radio-button border label="3000">3000USDT</el-radio-button>
                <el-radio-button border label="5000">5000USDT</el-radio-button>
                <el-radio-button border label="10000">10000USDT</el-radio-button>
                <el-radio-button border label="20000">20000USDT</el-radio-button>
                <el-radio-button border label="30000">30000USDT</el-radio-button>
              </el-radio-group>
            </el-form-item>

<!--            <el-form-item label="" prop="verCode" :rules="[]">
              <div>
                <el-input placeholder="谷歌验证码" v-model="moneyForm.verCode">
                  <template slot="prepend">谷歌验证码</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="Tg验证码:" prop="tgCode" :rules="[{ required: true, message: '纸飞机验证码不能为空', trigger: 'blur'}]">
              &lt;!&ndash;<el-input v-model="resetForm.tgCode" placeholder="请输入Tg验证码"></el-input>&ndash;&gt;
              <template>
                <el-col :span="10" style="margin-right: 10px">
                  <el-input v-model="moneyForm.tgCode" placeholder="请输入纸飞机验证码"></el-input>
                </el-col>
                <el-col :span="10">
                  <el-button type="primary" @click="getCode('/system/getTgCode/updateDeposit',60,'updateDeposit')" :disabled="codeDisabled.updateDeposit">{{codeName.updateDeposit}}</el-button>
                </el-col>
              </template>
            </el-form-item>-->

          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="depositVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitDeposit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--修改累计充值弹出框-->
    <div class="dialog">
      <el-dialog title="修改累计充值" :visible.sync="rechargeMoneyVisible" custom-class="common-dialog" :close-on-click-modal="false" width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width=""
                   :model="rechargeMoneyForm" ref="rechargeMoneyForm">

            <el-form-item label="" prop="rechargeTotal" :rules="[]">
              <div>
                <el-input placeholder="当前累计充值" v-model="rechargeMoneyForm.rechargeTotal" readonly>
                  <template slot="prepend">当前累计充值(USDT)</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="" prop="rechargeMoney" :rules="[]">
              <div style="margin-top: 15px;">
                <el-input placeholder="请输入金额(USDT)" v-model="rechargeMoneyForm.rechargeMoney" class="input-with-select">
                  <el-select style="width: 120px" v-model="rechargeMoneyForm.type" slot="prepend" placeholder="请选择">
                    <el-option label="加款" value="1"></el-option>
                    <el-option label="减款" value="0"></el-option>
                  </el-select>
                </el-input>
              </div>
            </el-form-item>

<!--            <el-form-item label="" prop="verCode" :rules="[]">
              <div>
                <el-input placeholder="谷歌验证码" v-model="rechargeMoneyForm.verCode">
                  <template slot="prepend">谷歌验证码</template>
                </el-input>
              </div>
            </el-form-item>

            <el-form-item label="Tg验证码:" prop="tgCode" :rules="[{ required: true, message: '纸飞机验证码不能为空', trigger: 'blur'}]">
              &lt;!&ndash;<el-input v-model="resetForm.tgCode" placeholder="请输入Tg验证码"></el-input>&ndash;&gt;
              <template>
                <el-col :span="10" style="margin-right: 10px">
                  <el-input v-model="rechargeMoneyForm.tgCode" placeholder="请输入纸飞机验证码"></el-input>
                </el-col>
                <el-col :span="10">
                  <el-button type="primary" @click="getCode('/system/getTgCode/updateRechargeMoney',60,'updateRechargeMoney')" :disabled="codeDisabled.updateRechargeMoney">{{codeName.updateRechargeMoney}}</el-button>
                </el-col>
              </template>
            </el-form-item>-->

          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="rechargeMoneyVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitRechargeMoney">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--添加邀请码弹出框-->
    <div class="dialog">
      <el-dialog title="密码显示"
                 :visible.sync="passwordVisible"
                 custom-class="common-dialog"
                 :close-on-click-modal="false"
                 @close="passwordVisibleClose('passwordForm')"
                 width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="70px"
                   :model="passwordForm" ref="passwordForm">
            <el-form-item label="会员ID" prop="userId" :rules="[{message: '会员ID不能为空', trigger: 'blur', required: true}]">
              <el-input placeholder="会员ID" v-model="passwordForm.userId" :style="'pointer-events: none;'"/>
            </el-form-item>
            <el-form-item label="手机号" prop="phone" :rules="[{message: '手机号不能为空', trigger: 'blur', required: true}]">
              <el-input placeholder="手机号" v-model="passwordForm.phone" :style="'pointer-events: none;'"/>
            </el-form-item>
<!--            <el-form-item label="验证码" prop="code" :rules="[{message: '验证码不能为空', trigger: 'blur', required: true}]">
              <el-input placeholder="验证码" v-model="passwordForm.code"/>
            </el-form-item>-->
            <template v-if="passwordShow">
              <el-form-item label="登录密码">
                <el-input placeholder="登录密码" v-model="passwordValue.password" :style="'pointer-events: none;'"/>
              </el-form-item>
              <!--<el-form-item label="支付密码">
                  <el-input placeholder="支付密码" v-model="passwordValue.payPassword" :style="'pointer-events: none;'"/>
              </el-form-item>-->
            </template>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="passwordVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitPasswordForm('passwordForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--重置密码-->
    <div class="dialog">
      <el-dialog :title="resetPwdForm.title"
                 :visible.sync="resetPwdVisible"
                 custom-class="common-dialog"
                 :close-on-click-modal="false"
                 @close="resetPwdVisibleClose('resetPwdForm')"
                 width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="80px"
                   :model="resetPwdForm" ref="resetPwdForm">
            <el-form-item label="会员ID" prop="userId" :rules="[{message: '会员ID不能为空', trigger: 'blur', required: true}]">
              <el-input placeholder="会员ID" v-model="resetPwdForm.userId" :style="'pointer-events: none;'"/>
            </el-form-item>
            <el-form-item label="手机号" prop="phone" :rules="[{message: '手机号不能为空', trigger: 'blur', required: true}]">
              <el-input placeholder="手机号" v-model="resetPwdForm.phone" :style="'pointer-events: none;'"/>
            </el-form-item>
            <el-form-item :label="resetPwdForm.pLabel" prop="password" :rules="[{message: resetPwdForm.pLabel + '不能为空', trigger: 'blur', required: true}]">
              <el-input type="password" show-password :placeholder="resetPwdForm.pLabel" v-model="resetPwdForm.password"/>
            </el-form-item>
<!--            <el-form-item label="验证码" prop="verCode" :rules="[{message: '谷歌验证码不能为空', trigger: 'blur', required: true}]">-->
<!--              <el-input placeholder="谷歌验证码" v-model="resetPwdForm.verCode"/>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="Tg验证码:" prop="tgCode" :rules="[{ required: true, message: '纸飞机验证码不能为空', trigger: 'blur'}]">-->
              <!--<el-input v-model="resetForm.tgCode" placeholder="请输入Tg验证码"></el-input>-->
<!--              <template>
                <el-col :span="10" style="margin-right: 10px">
                  <el-input v-model="resetPwdForm.tgCode" placeholder="请输入纸飞机验证码"></el-input>
                </el-col>
                <el-col :span="10">
                  <el-button type="primary" @click="getCode('/system/getTgCode/resetPassword',60,'resetPassword')" :disabled="codeDisabled.resetPassword">{{codeName.resetPassword}}</el-button>
                </el-col>
              </template>
            </el-form-item>-->
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="resetPwdVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitResetPwdForm('resetPwdForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--添加充值订单-->
    <div class="dialog">
      <el-dialog title="用户充值"
                 :visible.sync="rechargeVisible"
                 custom-class="common-dialog"
                 :close-on-click-modal="false"
                 @close="rechargeVisibleClose('rechargeForm')"
                 width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="70px"
                   :model="rechargeForm" ref="rechargeForm">
            <el-form-item label="会员ID" prop="userId" :rules="[{message: '会员ID不能为空', trigger: 'blur', required: true}]">
              <el-input placeholder="会员ID" v-model="rechargeForm.userId" :style="'pointer-events: none;'"/>
            </el-form-item>
            <el-form-item label="手机号" prop="phone" :rules="[{message: '手机号不能为空', trigger: 'blur', required: true}]">
              <el-input placeholder="手机号" v-model="rechargeForm.phone" :style="'pointer-events: none;'"/>
            </el-form-item>
            <el-form-item label="类型" prop="type" :rules="[{message: '请选择类型', trigger: 'blur', required: true}]">
              <el-select v-model="rechargeForm.type" placeholder="请选择类型" @change="balanceTypeChange" clearable>
                <el-option :key="1" label="智能账户充值" :value="1"/>
                <el-option :key="2" label="活期账户充值" :value="2"/>
              </el-select>
            </el-form-item>
            <el-form-item label="金额" prop="amount" :rules="[{message: '金额不能为空', trigger: 'blur', required: true}]">
              <el-input placeholder="金额" v-model="rechargeForm.amount"/>
            </el-form-item>

            <el-form-item label="说明" prop="explain" :rules="[]">
              <el-input type="textarea"
                        size="medium"
                        autosize
                        placeholder="说明"
                        v-model="rechargeForm.expound"
                        clearable>
              </el-input>
            </el-form-item>

<!--            <el-form-item label="验证码" prop="code" :rules="[{message: '验证码不能为空', trigger: 'blur', required: true}]">
              <el-input placeholder="谷歌验证码" v-model="rechargeForm.code"/>
            </el-form-item>

            <el-form-item label="Tg验证码:" prop="tgCode" :rules="[{ required: true, message: '纸飞机验证码不能为空', trigger: 'blur'}]">
              &lt;!&ndash;<el-input v-model="resetForm.tgCode" placeholder="请输入Tg验证码"></el-input>&ndash;&gt;
              <template>
                <el-col :span="10" style="margin-right: 10px">
                  <el-input v-model="rechargeForm.tgCode" placeholder="请输入纸飞机验证码"></el-input>
                </el-col>
                <el-col :span="10">
                  <el-button type="primary" @click="getCode('/system/getTgCode/recharge',60,'recharge')" :disabled="codeDisabled.recharge">{{codeName.recharge}}</el-button>
                </el-col>
              </template>
            </el-form-item>-->
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="rechargeVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submitRechargeForm('rechargeForm')">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!--&lt;!&ndash;添加邀请码弹出框&ndash;&gt;
    <div class="dialog">
        <el-dialog title="添加邀请码" :visible.sync="inviteVisible" custom-class="common-dialog" :close-on-click-modal="false" width="30%">
            <div class="dialog_body">
                <el-form label-position="right" status-icon
                         :model="inviteForm" ref="inviteForm">
                    <el-form-item label="用户ID" prop="userId" :rules="[{message: '用户ID不能为空', trigger: 'blur', required: true}]">
                        <el-input placeholder="用户ID" v-model="inviteForm.userId" disabled/>
                    </el-form-item>
                    <el-form-item label="佣金比例" prop="ratio" :rules="[{message: '佣金比例不能为空', trigger: 'blur', required: true}]">
                        <el-input placeholder="佣金比例" v-model="inviteForm.ratio"/>
                    </el-form-item>
                    <el-form-item label="邀请码" prop="inviteCode" :rules="[]">
                        <el-input placeholder="邀请码" v-model="inviteForm.inviteCode"/>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="inviteVisible = false">取 消</el-button>
                <el-button type="primary" size="small" @click="submitInviteForm('inviteForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>-->

    <div class="dialog">
      <el-dialog title="选择导出时间"
                 :visible.sync="exportVisible"
                 custom-class="common-dialog"
                 :close-on-click-modal="false"
                 @close="resetForm('form')"
                 width="30%">
        <div class="dialog_body">
          <el-form label-position="right" status-icon label-width="90px"
                   :model="form" ref="form">
            <el-form-item label="代理" prop="agentId" :rules="[{message: '请选择代理', trigger: 'blur', required: false}]">
              <el-select filterable
                         v-model="form.agentId" clearable
                         placeholder="请选择代理"
                         size="medium" class="mr10 mb-10">
                <el-option v-for="(option, index) in agents" :key="index" :label="option.name" :value="option.id"/>
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间" prop="startTime" :rules="[{message: '请选择开始时间', trigger: 'blur', required: true}]">
              <el-date-picker v-model="form.startTime"
                              placeholder="开始时间"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              type='datetime' align="right"
                              size="medium" class="mr10 mb-10"/>
            </el-form-item>
            <el-form-item label="结束时间" prop="endTime" :rules="[{message: '请选择结束时间', trigger: 'blur', required: true}]">
              <el-date-picker v-model="form.endTime"
                              placeholder="结束时间"
                              value-format="yyyy-MM-dd HH:mm:ss"
                              type='datetime' align="right"
                              size="medium" class="mr10 mb-10"/>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="exportVisible = false">取 消</el-button>
          <el-button type="primary" size="small" @click="submit('form')">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import message from "../../utils/message";
import request from  "@/utils/axios.js";
//import {excelDownload} from "../../utils/download";

export default {
  name: "User",
  components: {CommonTable},
  data(){
    return{
      exportVisible: false,
      form: {
        startTime: '',
        endTime: '',
        agentId: '',
      },
      agents: [],
      codeName:{
        updateMoney: '获取验证码',
        updateDeposit: '获取验证码',
        updateRechargeMoney: '获取验证码',
        resetPassword: '获取验证码',
        resetPayPassword: '获取验证码',
        recharge: '获取验证码'
      },
      codeDisabled: {
        updateMoney: false,
        updateDeposit: false,
        updateRechargeMoney: false,
        resetPassword: false,
        resetPayPassword: false,
        recharge: false
      },
      moneyVisible: false,
      currentUser: {},
      moneyForm:{
        //balance:0,
        //freeze:0
        balanceType: null,
        money: '',
        verCode: '',
        type: null,
        tgCode: ''
      },
      rechargeMoneyForm:{
        rechargeMoney: '',
        rechargeTotal: '',
        verCode: '',
        type: null,
        tgCode: ''
      },
      depositVisible: false,
      rechargeMoneyVisible: false,
      passwordVisible: false,
      passwordForm: {
        userId: null,
        phone: '',
        code: '',
        tgCode: ''
      },
      passwordValue: {
        password: '',
        //payPassword: ''
      },
      passwordShow: false,
      /*inviteVisible: false,
      inviteForm: {
          userId: null,
          ratio: null,
          inviteCode: '',
      },*/
      activeName: 'balance',
      rechargeVisible: false,
      rechargeForm: {
        userId: '',
        phone: '',
        amount: '',
        type: '',
        expound: '',
        code: '',
        tgCode: ''
      },
      resetPwdVisible: false,
      resetPwdForm: {
        userId: '',
        phone: '',
        password: '',
        title: '',
        pLabel: '',
        url: '',
        verCode: '',
        tgCode: ''
      },
      searchs:[
        {
          name: 'phone',
          placeholder: '手机号',
          type: 'input'
        },  {
          name: 'username',
          placeholder: '用户昵称',
          type: 'input'
        },
        {
          name: 'agentId',
          placeholder: '代理',
          type: 'select',
          selectUrl: '/agent/getAll',
          selectValue: []
        },
        {
          name: 'parentPhone',
          placeholder: '上级',
          type: 'input'
        },
        {
          name: 'inviteCode',
          placeholder: '邀请码',
          type: 'input'
        },
   /*     {
          name: 'online',
          placeholder: '在线状态',
          type: 'select',
          selectValue:[
            {
              key: 1,
              value: "在线"
            },
            {
              key: 0,
              value: "离线"
            }
          ]
        },*/
        {
          name: 'status',
          placeholder: '请选择状态',
          type: 'select',
          selectValue:[
            {
              key: "1",
              value: "正常"
            },
            {
              key: "0",
              value: "锁定"
            }
          ]
        }/*,{
          name: 'sort',
          placeholder: '排序字段',
          type: 'select',
          selectValue: [
            {
              key: "walletBalance",
              value: '智能账户',
            },
            {
              key: "promotionBalance",
              value: '活期账户',
            }
          ],
        }*//*,{
          name: 'order',
          placeholder: '排序顺序',
          type: 'select',
          selectValue: [
            {
              key: "asc",
              value: '正叙',
            },
            {
              key: "desc",
              value: '倒叙',
            }
          ],
        },*/
       /* {
          name: 'participate',
          placeholder: '请选择是否参与计算',
          type: 'select',
          selectValue:[
            {
              key: "1",
              value: "会员账号"
            },
            {
              key: "0",
              value: "测试账号"
            }
          ]
        },
        {
          name: 'realizable',
          placeholder: '请选择是否可提现',
          type: 'select',
          selectValue:[
            {
              key: "1",
              value: "允许"
            },
            {
              key: "0",
              value: "禁止"
            }
          ]
        }*/,
        {
          name: 'startTime',
          placeholder: '开始时间',
          type: 'dateTime'
        },
        {
          name: 'endTime',
          placeholder: '结束时间',
          type: 'dateTime'
        }
      ],
      permission:{
        add: 'userInfo:add',
        update: 'userInfo:update',
        delete: 'userInfo:delete',
        deleteBatch: 'userInfo:deleteBatch'
      },
      url: {
        get: '/userInfo/listByCondition',
        add: '/userInfo/add',
        update: '/userInfo/update',
        delete: '/userInfo/delete/',
        delete_batch: '/userInfo/deleteBatch',
        status: '/userInfo/status'
      },
      tableColumns: [{
        field: 'id',
        label: 'ID',
        show: false,
        detail: true,
        width: '75',
      },{
        field: 'userImg',
        label: '头像',
        show: false,
        detail: false,
        width: '75',
        img: true
      }, {
        field: 'phone',
        label: '手机号',
        show: true,
        detail: true,
        width: '',
      }, {
        field: 'username',
        label: '用户昵称',
        show: false,
        detail: true,
        width: '',
      },{
        field: 'email',
        label: '邮箱',
        show: false,
        detail: false,
        width: '',
      }, {
        field: 'agentId',
        label: '代理商',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      },{
        field: 'invitePhone',
        label: '上级',
        show: true,
        detail: true,
        width: '',
      },{
        field: 'balance',
        label: '余额（元）',
        /*show: {
            type: 'money'
        },*/
        detail: false,
        show: false,
        width: '',
      },{
        field: 'walletBalance',
        label: '智能账户',
        show: false,
        detail: false,
        width: '',
      },{
        field: 'promotionBalance',
        label: '积分',
        show: false,
        detail: false,
        width: '',
      },{
        field: 'freeze',
        label: '冻结金额',
        show: false,
        detail: false,
        width: '',
      },
        {
        field: 'depositAmount',
        label: '智能账户存款额度',
        show: false,
        detail: false,
        width: '',
      }, {
        field: 'promotionAccountBalance',
        label: '积分',
        show: true,
        detail: false,
        width: '',
      }, {
        field: 'promotionDeposit',
        label: '活期存款额度',
        show: false,
        detail: false,
        width: '',
      },
        {
        field: 'rechargeTotal',
        label: '累计充值',
        show: false,
        detail: false,
        width: '',
      }, {
        field: 'withdrawalTotal',
        label: '累计提现',
        show: false,
        detail: false,
        width: '',
      }, {
        field: 'lev1',
        label: 'lev1',
        show: false,
        detail: false,
        width: '',
      }, {
        field: 'lev2',
        label: 'lev2',
        show: false,
        detail: false,
        width: '',
      }, {
        field: 'lev3',
        label: 'lev3',
        show: false,
        detail: false,
        width: '',
      },
      //   {
      //   field: 'effectiveUser',
      //   label: '有效人数',
      //   show: true,
      //   detail: true,
      //   width: '',
      // },
        {
        field: 'mining',
        label: '矿机等级',
        show: false,
        detail: false,
        width: '',
      }, {
        field: 'rechargeMoney',
        label: '团队充值',
        show: false,
        detail: false,
        width: '',
      }, {
        field: 'withdrawalMoney',
        label: '团队出款',
        show: false,
        detail: false,
        width: '',
      }/*,{
                    field: 'ratio',
                    label: '佣金比例',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    detail: false,
                    width: '',
                }*/,{
        field: 'inviteCode',
        label: '邀请码',
        show: true,
        width: '',
      },{
        field: 'points',
        label: '会员积分',
        show: false,
        detail: false,
        width: '',
      },{
        field: 'registerIp',
        label: '注册IP',
        show: true,
        detail: true,
        width: '',
      },{
        field: 'location',
        label: '注册地区',
        show: true,
        detail: true,
        width: '',
      }/*,{
                    field: 'commission',
                    label: '平台抽成',
                    show: {
                        type: 'thousandthsRatio'
                    },
                    detail: true,
                    width: '',
                },{
                    field: 'userGroupId',
                    label: '会员分组',
                    selectUrl: '/userGroup/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    detail: false,
                    width: '',
                },{
                    field: 'score',
                    label: '积分',
                    show: true,
                    detail: true,
                    width: '',
                },{
                    field: 'online',
                    label: '是否在线',
                    show: {
                        type: 'tag',
                        tags:[
                            {
                                key: 1,
                                value: '在线',
                                type: 'success'
                            },{
                                key: 0,
                                value: '离线',
                                type: 'warning'
                            }
                        ]
                    },
                    width: '',
                }*/,{
        field: 'participate',
        label: '参与计算',
          show: false,
       /* show: {
          type: 'status',
          url: '/userInfo/update/participate'
        },
        values: [{
          type: 'primary',
          key: 1,
          value: '会员账号'
        }, {
          type: 'warning',
          key: 0,
          value: '测试账号'
        }],
        width: '80px',
        confirm: 'phone',
        permission: 'userInfo:update:participate'*/
      },{
        field: 'realizable',
        label: '可提现',
          show: false,
      /*  show: {
          type: 'status',
          url: '/userInfo/update/realizable'
        },
        values: [{
          type: 'success',
          key: 1,
          value: '允许'
        }, {
          type: 'danger',
          key: 0,
          value: '禁止'
        }],
        width: '80px',
        confirm: 'phone',
        permission: 'userInfo:update'*/
      },{
        field: 'loginTime',
        label: '登录时间',
        // show: true,
        detail: true,
        width: '',
      },{
          field: 'openId',
          label: '抖音',
          // show: true,
          detail: true,
          width: '',
          show: true,
        },{
          field: 'wxOpenId',
          label: '微信',
          // show: true,
          detail: true,
          width: '',
          show: true,
        },{
          field: 'isVip',
          label: 'VIP',
          show: true,
          detail: false,
          width: '90',
          status: true,
        },{
          field: 'isLimit',
          label: '是否量化限制',
          show: false,
          detail: false,
          width: '90',
          status: true,
        },{
          field: 'userAddress',
          label: '钱包地址',
          show: false,
          detail: false,
          width: '90',
        }, {
          field: 'expiryTime',  // 字段名
          label: '到期时间',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },{
          field: 'videoNumber',  // 字段名
          label: '每日视频数量',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        },
        {
          field: 'isAuthorization',
          label: '授权状态',
          show: {
            type: 'tag',
            tags: [{
              key: 1,
              value: '已授权',
              type: 'success'
            },{
              key: 0,
              value: '未授权',
              type: 'warning'
            }]
          },
          width: '100'
        },
        {
        field: 'registerTime',
        label: '注册时间',
        show: true,
        detail: false,
        width: '90',
      },{
          field: 'status',
          label: '状态',
          show: true,
          detail: false,
          width: '90',
          status: true,
        }],
      operate:[{
        icon: 'el-icon-money',
        type: 'text',
        text: '积分',
        exist: () => {
          return this.$refs.table.havePermission('userInfo:updateMoney')
        },
        handle: (row) => {
          // console.log(row);
          this.moneyForm.id = row.id;
          this.currentUser = row;
          // this.moneyForm.balance = '';
          this.moneyForm.balanceType = 2;
          this.moneyForm.verCode = '';
          this.moneyForm.type = '';
          this.moneyForm.money = '';
          this.moneyForm.tgCode = '';
          this.moneyVisible = true;
          this.moneyForm.balance = this.currentUser.promotionAccountBalance;
          //this.moneyForm.balance = row.walletBalance;
          //this.moneyForm.freeze = row.freeze;
        }
      },/*, {
        icon: 'el-icon-money',
        type: 'text',
        text: '额度',
        exist: () => {
          return this.$refs.table.havePermission('userInfo:updateDeposit')
        },
        handle: (row) => {
          this.moneyForm.id = row.id;
          this.currentUser = row;
          this.moneyForm.balance = '';
          this.moneyForm.balanceType = '';
          this.moneyForm.verCode = '';
          this.moneyForm.type = '';
          this.moneyForm.money = '';
          this.moneyForm.tgCode = '';
          this.depositVisible = true;
        }
      }*//* {
        icon: 'el-icon-money',
        type: 'text',
        text: '累计充值',
        exist: () => {
          return this.$refs.table.havePermission('userInfo:updateRechargeMoney')
        },
        handle: (row) => {
          this.rechargeMoneyForm.id = row.id;
          this.currentUser = row;
          this.rechargeMoneyForm.rechargeMoney = '';
          this.rechargeMoneyForm.rechargeTotal = row.rechargeTotal;
          this.rechargeMoneyForm.verCode = '';
          this.rechargeMoneyForm.type = '';
          this.rechargeMoneyForm.tgCode = '';
          this.rechargeMoneyVisible = true;
        }
      }*//*,{
                    icon: 'el-icon-wallet',
                    type: 'text',
                    text: '额度',
                    handle: (row) => {
                        // 跳转用户额度
                        this.$router.push({
                            name: 'Quota',
                            params: {
                                username: row.username
                            }
                        });
                    }
                },{
                    icon: 'el-icon-edit',
                    type: 'text',
                    text: '邀请码',
                    handle: (row) => {
                        console.log(row);
                        this.inviteForm.userId = row.id;
                        this.inviteVisible = true;
                    }
                }*/{
        icon: 'el-icon-lock',
        type: 'text',
        text: '重置密码',
        //title: '确定重置该用户密码？',
        handle: (row) => {
          this.resetPwdForm.userId = row.id;
          this.resetPwdForm.phone = row.phone;
          this.resetPwdForm.url = '/userInfo/password/reset';
          this.resetPwdForm.title = '重置登录密码';
          this.resetPwdForm.pLabel = '登录密码';
          this.resetPwdForm.verCode = '';
          this.resetPwdForm.tgCode = '';
          this.resetPwdVisible = true;
          /*const password = '123456';
          this.$axios.post({
              url: '/userInfo/password/reset',
              data: {id: row.id, password: password},
              success: (res) => {
                  if(res.code === 0){
                      this.$message.success('密码重置成功');
                      //this.getData();
                  }else{
                      this.$message.error('密码重置失败');
                  }
              }
          });*/
        }
      }/*,{
        icon: 'el-icon-coin',
        type: 'text',
        text: '支付密码',
        //title: '确定重置该用户支付密码？',
        handle: (row) => {
          this.resetPwdForm.userId = row.id;
          this.resetPwdForm.phone = row.phone;
          this.resetPwdForm.url = '/userInfo/payPassword/reset';
          this.resetPwdForm.title = '重置支付密码';
          this.resetPwdForm.pLabel = '支付密码';
          this.resetPwdForm.verCode = '';
          this.resetPwdForm.tgCode = '';
          this.resetPwdVisible = true;
          /!*this.$axios.post({
              url: '/userInfo/payPassword/reset',
              data: {id: row.id},
              success: (res) => {
                  if(res.code === 0){
                      this.$message.success('支付密码重置成功');
                  }else{
                      this.$message.error('支付密码重置失败');
                  }
              }
          });*!/
        }
      }*//*,{
                    icon: 'el-icon-view',
                    type: 'text',
                    text: '查看密码',
                    handle: (row) => {
                        this.passwordForm.userId = row.id;
                        this.passwordForm.phone = row.phone;
                        this.passwordVisible = true;
                    }
                }*//*,{
        icon: 'el-icon-discount',
        type: 'text',
        text: '充值',
        handle: (row) => {
          this.rechargeForm.userId = row.id;
          this.rechargeForm.phone = row.phone;
          this.rechargeForm.code = '';
          this.rechargeForm.tgCode = '';
          this.rechargeVisible = true;
        }
      }*/],
      formFields: {
        addTitle: '添加用户',
        updateTitle: '修改用户',
        labelWidth: '105px',
        model: [{
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules:[{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        },{
          field: 'phone',
          label: '手机号：',
          type: 'number',
          maxlength: 16,
          placeholder: 'Phone',
          rules: [{
            message: '请输入手机号', trigger: 'blur', required: true
          }],
          add: true,
          update: false,
        },{
          field: 'password',
          label: '密码：',
          type: 'password',
          placeholder: 'Password',
          rules: [{
            message: '请输入密码', trigger: 'blur', required: true
          },{
            min: 6, max: 20, message: '密码在6~20个长度内', trigger: 'blur', required: true
          },{
            pattern: /^\S*$/, message: '密码不能包含空格',  trigger: 'blur', required: true
          }],
          add: true,
          update: false,
        }, {
          field: 'participate',
          label: '参与计算',
          type: 'select',
          selectData: [{
            id: 1,
            name: '参与',
          }, {
            id: 0,
            name: '不参与',
          }],
          placeholder: '请选择',
          rules: [{
            message: '请选择', trigger: 'blur', required: true
          }],
          add: false,
          update: false,
        },{
          field: 'mining',
          label: '矿机等级：',
          type: 'number',
          placeholder: '矿机等级',
          rules: [{
            message: '请输入矿机等级', trigger: 'blur', required: true
          }],
          add: false,
          update: false,
        },{
          field: 'freeze',
          label: '冻结金额：',
          type: 'number',
          placeholder: '冻结金额',
          rules: [{
            message: '请输入冻结金额', trigger: 'blur', required: true
          }],
          add: false,
          update: false,
        },{
          field: 'userAddress',
          label: '用户钱包地址：',
          type: 'input',
          placeholder: '用户钱包地址',
          rules: [{
            message: '请输入用户钱包地址：', trigger: 'blur', required: true
          }],
          add: false,
          update: false,
        },{
          field: 'payPassword',
          label: '支付密码：',
          type: 'password',
          placeholder: '支付密码',
          rules: [{
            message: '请输入支付密码', trigger: 'blur', required: true
          },{
            min: 6, max: 20, message: '支付密码在6~20个长度内', trigger: 'blur', required: true
          },{
            pattern: /^\S*$/, message: '支付密码不能包含空格',  trigger: 'blur', required: true
          }],
          add: false,
          update: false,
        },{
          field: 'expiryTime',
          label: '到期时间：',
          type: 'dateTime',
          placeholder: '到期时间',
          rules: [],
          add: true,
          update: true,
        },{
          field: 'videoNumber',
          label: '每日视频数量：',
          type: 'number',
          placeholder: '每日视频数量',
          rules: [],
          add: true,
          update: true,
        }/*, {
          field: 'tgCode',
          label: '纸飞机验证码',
          type: 'code',
          placeholder: '纸飞机验证码',
          rules:[{
            message: '请输入纸飞机验证码', trigger: 'blur', required: true
          }],
          add: {
            url: '/system/getTgCode/addUser',
            second: 60
          },
          update: false,
        }*/],
      },
      buttons: [{
        icon: 'el-icon-download',
        type: 'warning',
        text: '导出',
        permission: 'userInfo:export',
        click: () => {
          this.tableColumns.some(item => {
            if (item.field == 'agentId') {
              this.agents = item.selectData;
            }
          })
          this.exportVisible = true;
        }
      }]
    }
  },
  methods: {

    /**
     * 获取验证码
     * @param url
     */
    getCode(url,second,type){
      if (!second) second = 60;
      this.codeName[type] = second + "s后获取";
      this.codeDisabled[type] = true;
      request.get({
        url: url,
        data: {},
      })
      this.getCodeSeconds(second,type);

    },
    getCodeSeconds(second,type){
      setTimeout(()=>{
        if (second > 1){
          this.codeName[type] = (second - 1) + "s后获取";
          this.getCodeSeconds(second - 1,type);
        }else {
          this.codeDisabled[type] = false;
          this.codeName[type] = "获取验证码";
        }
      },1000)
    },

    //重置表单
    resetForm(formName){
      this.$refs[formName].resetFields();
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          request.get({
            url: '/userInfo/export',
            data: this.form,
            confirm: '确定导出Excel？',
            //responseType: 'arraybuffer',
            success: (res) => {
              if (res.code === 0) {
                message.success("会员信息导出任务正在进行中");
                this.exportVisible = false;
              } else {
                message.error(res.msg);
              }
              /*if (res.code) {
                  message.error(res.msg);
                  return;
              }
              excelDownload(res, "会员信息导出明细.xlsx");
              /!*this.$msgbox({
                  title: '下载地址',
                  message: '下载地址为：' + res.data + '，点击确定跳转下载！'
              }).then(() => {
                  window.open(res.data,"_blank");
              }).catch()*!/
              this.exportVisible = false;*/
            }
          })
        }
      })
    },
    submitMoneyForm(){
      if (this.activeName == 'freeze'){
        message.warning("待实现");
        return;
      }
      let type = this.moneyForm.type == 1 ? '加款' : '减款';
      this.moneyForm.operation = this.activeName;
      request.post({
        url: '/userInfo/updateMoney',
        data: this.moneyForm,
        confirm: '确定进行' + type + '操作？',
        success: (data) => {
          if (data.code == 0){
            message.success(type + "成功");
            this.moneyVisible = false;
            this.$refs.table.getData();
          }else {
            message.error(data.msg || type + "失败");
          }
        }
      });
    },
    handleClick(tab){
      console.log(tab.label);
      //console.log(this.activeName);
    },
    submitDeposit() {
      let type = this.moneyForm.type == 1 ? '加款' : '减款';
      request.post({
        url: '/userInfo/updateDeposit',
        data: this.moneyForm,
        confirm: '确定进行' + type + '操作？',
        success: (data) => {
          if (data.code == 0){
            message.success(type + "成功");
            this.depositVisible = false;
            this.$refs.table.getData();
          }else {
            message.error(data.msg || type + "失败");
          }
        }
      });
    },
    submitRechargeMoney() {
      let type = this.rechargeMoneyForm.type == 1 ? '加款' : '减款';
      request.post({
        url: '/userInfo/updateRechargeMoney',
        data: this.rechargeMoneyForm,
        confirm: '确定进行' + type + '操作？',
        success: (data) => {
          if (data.code == 0){
            message.success(type + "成功");
            this.rechargeMoneyVisible = false;
            this.$refs.table.getData();
          }else {
            message.error(data.msg || type + "失败");
          }
        }
      });
    },
    /*submitInviteForm(formName) {
        this.$refs[formName].validate((valid) => {
            if (valid) {
                this.$axios.post({
                    url: '/invite/add',
                    data: this.inviteForm,
                    confirm: '确定添加邀请码？',
                    success: (data) => {
                        if (data.code === 0){
                            message.success('邀请码添加成功');
                            this.inviteVisible = false;
                        }else {
                            message.error(data.msg || "失败");
                        }
                    }
                })
            }
        })
    },*/
    submitPasswordForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post({
            url: '/userInfo/password/show',
            data: this.passwordForm,
            success: (res) => {
              if (res.code === 0) {
                this.passwordValue.password = res.data.password;
                //this.passwordValue.payPassword = res.data.payPassword;
                this.passwordShow = true;
              } else {
                message.error(res.msg || "失败");
              }
            }
          });
        }
      })
    },
    passwordVisibleClose(formName) {
      this.$refs[formName].resetFields();
      this.passwordValue.password = '';
      //this.passwordValue.payPassword = '';
      this.passwordShow = false;
    },
    submitRechargeForm (formName) {
      console.log(this.rechargeForm)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post({
            url: '/recharge/manual/add',
            data: this.rechargeForm,
            success: (res) => {
              if (res.code === 0) {
                message.success('添加充值订单成功');
                this.rechargeVisible = false;
              } else {
                message.error(res.msg || "添加充值订单失败");
              }
            }
          });
        }
      })
    },
    rechargeVisibleClose(formName) {
      this.$refs[formName].resetFields();
    },
    balanceTypeChange() {
      if (this.moneyForm.balanceType === 1) {
        this.moneyForm.balance = this.currentUser.walletBalance;
      } else if (this.moneyForm.balanceType === 2) {
        this.moneyForm.balance = this.currentUser.promotionAccountBalance;
      } else if (this.moneyForm.balanceType === 3) {
        this.moneyForm.balance = this.currentUser.promotionBalance;
      } else {
        this.moneyForm.balance = null;
      }
    },
    depositTypeChange() {
      if (this.moneyForm.balanceType === 1) {
        this.moneyForm.balance = this.currentUser.depositAmount;
      } else if (this.moneyForm.balanceType === 2) {
        this.moneyForm.balance = this.currentUser.promotionDeposit;
      } else {
        this.moneyForm.balance = null;
      }
    },
    submitResetPwdForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$axios.post({
            url: this.resetPwdForm.url,
            data: {id: this.resetPwdForm.userId, password: this.resetPwdForm.password, verCode: this.resetPwdForm.verCode, tgCode: this.resetPwdForm.tgCode},
            success: (res) => {
              if (res.code === 0) {
                this.resetPwdVisible = false;
                message.success("重置" + this.resetPwdForm.pLabel + "成功");
              } else {
                message.error(res.msg || "重置" + this.resetPwdForm.pLabel + "失败");
              }
            }
          });
        }
      })
    },
    resetPwdVisibleClose(formName) {
      this.$refs[formName].resetFields();
    },
  },
  computed: {
    newMoney(){
      return this.moneyForm.money;
    },
    newFixedMoney(){
      return this.moneyForm.fixedMoney;
    }
  },
  watch:{
    newMoney(val){
      this.moneyForm.fixedMoney = val;
    },
    newFixedMoney(val){
      this.moneyForm.money = val;
    }
  }
}
</script>

<style scoped>

</style>
